export enum InputType {
  text = 'text',
  password = 'password'
}
